/**
 * What an attachment may be, shared by every attachment picker: the cap per
 * entity and the MIME types the file choosers accept, split so a picker can
 * offer images and documents apart (the create-event flow's "+ Image" and
 * "+ Document").
 */

/** How many files an entity may carry. */
export const MAX_ATTACHMENTS = 5

export const IMAGE_MIME_TYPES = ['image/jpeg', 'image/png', 'image/gif', 'image/webp', 'image/heic']

export const DOCUMENT_MIME_TYPES = [
	'application/pdf',
	'application/msword',
	'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
	'application/vnd.ms-excel',
	'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
	'application/vnd.ms-powerpoint',
	'application/vnd.openxmlformats-officedocument.presentationml.presentation',
	'text/plain',
	'text/csv',
]

/** `accept` lists for a file input. */
export const IMAGE_ACCEPT = IMAGE_MIME_TYPES.join(',')
export const DOCUMENT_ACCEPT = DOCUMENT_MIME_TYPES.join(',')
export const ATTACHMENT_ACCEPT = [...IMAGE_MIME_TYPES, ...DOCUMENT_MIME_TYPES].join(',')

/** The toast for a pick that would run past the cap. */
export const overCapMessage = (remaining: number): string =>
	`You can add ${remaining} more attachment${remaining !== 1 ? 's' : ''}.`
